import { Injectable, inject } from '@angular/core';

import { ApiProvider } from '@providers/common/api.service';
import { consultasMatriz, consultasMatrizUrl } from '@common/constants';
import { firstValueFrom } from 'rxjs';

/**
 * @name MatrizEstatusService
 * @desc Servicio usado para hacer las peticiones de las vistas de matris-estatus-equipo
 */
@Injectable({
  providedIn: 'root'
})
export class MatrizEstatusService {
  private api = inject(ApiProvider);

  private matrizEstatusFields: any = {
    "Desc_Estatus": "Estatus",
    "CDDescripcion": "Ciudad"
  }

  /**
   * @name translate
   * @desc Funcion que traduce el id de un campo a su valor de texto
   */
  translate(val: string): string {
    return this.matrizEstatusFields[val] || val;
  }

  /**
   * @name getMatrizData
   * @desc Funcion que obtiene la informacion de MatrizEstatusEquipoPage
   */
  getMatrizData(filters: any) {
    return this.api.post(consultasMatriz.resumen, filters, consultasMatrizUrl);
  }

  /**
   * @name getTipoEquipo
   * @desc Funcion que obtiene la informacion del filtro TipoEquipo
   */
  getTipoEquipo() {
    return new Promise((resolve) => {
      resolve([{
        value: "T",
        text: "Todos"
      }, {
        value: "S",
        text: "Shuttle"
      }, {
        value: "N",
        text: "Nacional"
      }]);
    });
  }

  /**
   * @name getIdCD
   * @desc Funcion que obtiene la informacion del filtro IdCD
   */
  getIdCD() {
    return firstValueFrom(this.api.post(consultasMatriz.cd, {}, consultasMatrizUrl));
  }

  /**
   * @name getEstatus
   * @desc Funcion que obtiene la informacion del filtro Estatus
   */
  getEstatus() {
    return firstValueFrom(this.api.post(consultasMatriz.estatus, {}, consultasMatrizUrl));
  }

  /**
   * @name getEconomico
   * @desc Funcion que obtiene la informacion del filtro Economico
   */
  getEconomico() {
    return firstValueFrom(this.api.post(consultasMatriz.economico, {}, consultasMatrizUrl));
  }

  /**
   * @name getCliente
   * @desc Funcion que obtiene la informacion del filtro Cliente
   */
  getCliente() {
    return firstValueFrom(this.api.post(consultasMatriz.cliente, {}, consultasMatrizUrl));
  }

  /**
   * @name getDetails
   * @desc Funcion que obtiene la informacion del detalle del resumen de trafico
   */
  getDetails(IdCD: string, IdEstatus: string) {
    return this.api.post(consultasMatriz.detalle, {
      IdCD: IdCD,
      IdEstatus: IdEstatus
    }, consultasMatrizUrl);
  }

  /**
   * @name getProgramacionSemanal
   * @desc Funcion que obtiene la informacion de la vista ProgramacionCargaPage
   */
  getProgramacionSemanal(date: Date, filters: any) {
    const body: any = {
      FechaInicio: date
    }
    if (filters) {
      body["TipoEquipo"] = filters.TipoEquipo;
      body["IdCD"] = filters.IdCD;
      body["Economico"] = filters.Economico;
      body["Cliente"] = filters.Cliente;
    }
    return this.api.post(consultasMatriz.programacion, body, consultasMatrizUrl);
  }

  /**
   * @name updateProgramacion
   * @desc Funcion que actualiza la informacion de ProgramacionCargaPage
   */
  updateProgramacionSemanal(data: any) {
    return this.api.post(consultasMatriz.updateProgramacion, data, consultasMatrizUrl);
  }
}
